import React, { FC } from 'react';
import { Typography, List, ListItem, ListItemText } from '@mui/material';
import { formatDateOnly } from '../Formatters';
import { StyledLink } from '../Components';
import { useQuery } from '@apollo/client';
import LoadingSpinner from '../LoadingSpinner';
import { StyledPaper } from '../theme';
import { GET_RELEASES_FOR_USER } from './home.graphql';
import { GetReleasesForUserQuery } from '../__generated__/graphql';
import { Unpacked } from '../graphQLTypes/types';
import { useUserContext } from '../UserContext';

export const MyReleases: FC<{ numberOfReleases?: number }> = ({ numberOfReleases = 5 }) => {
  const { userId } = useUserContext();
  const { data } = useQuery(GET_RELEASES_FOR_USER, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <StyledPaper>
      <Typography variant="h5" component="h3">
        Mine sist publiserte anvisninger
      </Typography>
      {!data && <LoadingSpinner />}
      {data?.releases && (
        <List dense>
          {data.releases
            .slice(0, numberOfReleases)
            .filter((x) => !!x)
            .map((g) => (
              <GuideListItem key={g?.id} guide={g} />
            ))}
        </List>
      )}
      <StyledLink to="/guide?mine=1">Se alle mine anvisninger</StyledLink>
    </StyledPaper>
  );
};

type Guide = NonNullable<Unpacked<NonNullable<GetReleasesForUserQuery['releases']>>>;
const GuideListItem: FC<{ guide: Guide }> = ({ guide }) => {
  return (
    <ListItem key={guide.id}>
      <ListItemText
        primary={
          <StyledLink to={`/guide/${guide.guideId}`}>
            {guide.docName} - {guide.title}
          </StyledLink>
        }
        secondary={guide.archivedAt ? `Arkivert ${formatDateOnly(guide.archivedAt)}` : `Publisert ${formatDateOnly(guide.publishedAt)}`}
      />
    </ListItem>
  );
};
